import React, { memo, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import CurrentOrgContext from '../../Context/CurrentOrgContext';

import SearchByNameDropdown from './SearchByNameDropdown';
import SearchByOrgDropdown from './SearchByOrgDropdown';
import SortByDateButton from './SortByDateButton';
import StatusSelectDropdown from './StatusSelectDropdown';

function AlertsTableHeader({
  asset,
  assetView,
  handleAssetSelected,
  handleEcosystemToggle,
  handleOrgSelected,
  handleRuleSelected,
  handleSortClick,
  handleStatusSelected,
  includeChildren,
  orgIdFilter,
  selectedStatus,
  sort,
}) {
  const currentOrg = useContext(CurrentOrgContext) || {};
  const orgID = useMemo(
    () => (assetView ? asset?.orgID : orgIdFilter || currentOrg?._id),
    [assetView, asset?.orgID, currentOrg?._id, orgIdFilter]
  );

  return (
    <tr>
      <th scope="col" className="col-status sticky-top bg-white border-top-0">
        <StatusSelectDropdown
          selectedStatus={selectedStatus}
          handleStatusSelected={handleStatusSelected}
        />
      </th>
      {assetView ? null : (
        <th
          scope="col"
          className="text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white border-top-0"
        >
          <SearchByNameDropdown
            handleAssetSelected={handleAssetSelected}
            includeChildren={includeChildren}
            orgID={orgID}
            orgIdFilter={orgIdFilter}
            resource="Asset"
          />
        </th>
      )}
      <th
        scope="col"
        className="text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white col-rule-name border-top-0"
      >
        <SearchByNameDropdown
          assetView={assetView}
          handleRuleSelected={handleRuleSelected}
          includeChildren={includeChildren}
          orgID={orgID}
          orgIdFilter={orgIdFilter}
          resource="Rule"
        />
      </th>
      {assetView ? null : (
        <th
          scope="col"
          className="text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white border-top-0"
        >
          <SearchByOrgDropdown
            handleEcosystemToggle={handleEcosystemToggle}
            handleOrgSelected={handleOrgSelected}
            includeChildren={includeChildren}
            orgID={orgID}
            orgIdFilter={orgIdFilter}
          />
        </th>
      )}
      <th
        scope="col"
        className="col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0"
      >
        <SortByDateButton
          displayText="Detected At"
          sort={sort}
          handleSortClick={handleSortClick}
        />
      </th>
      {selectedStatus === 'positive' ? null : (
        <th
          scope="col"
          className="col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0"
        >
          <SortByDateButton
            displayText="Resolved"
            sort={sort}
            handleSortClick={handleSortClick}
          />
        </th>
      )}
      {['Conditions', 'Location'].map((h) => (
        <th
          scope="col"
          key={h}
          className={`text-left text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0 col-${h.toLowerCase()}`}
        >
          {h}
        </th>
      ))}
    </tr>
  );
}

AlertsTableHeader.propTypes = {
  asset: PropTypes.shape({
    _id: PropTypes.string,
    orgID: PropTypes.string,
  }),
  assetView: PropTypes.bool,
  handleAssetSelected: PropTypes.func,
  handleEcosystemToggle: PropTypes.func,
  handleOrgSelected: PropTypes.func,
  handleRuleSelected: PropTypes.func,
  handleSortClick: PropTypes.func,
  handleStatusSelected: PropTypes.func,
  includeChildren: PropTypes.bool,
  orgIdFilter: PropTypes.string,
  selectedStatus: PropTypes.oneOf(['positive', 'negative', 'all']),
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['TriggeredAt', 'DetectedAt']),
    direction: PropTypes.oneOf(['ASC', 'DESC']),
  }),
  tab: PropTypes.oneOf(['alerts', 'dm1']),
};

export default memo(AlertsTableHeader);
